/**
 * Decodes a base64 string with proper UTF-8 support.
 * Unlike atob() which produces Latin-1, this correctly handles
 * multi-byte UTF-8 characters (e.g. é, è, ê).
 */
export function decodeBase64Utf8(base64: string): string {
  const binaryString = atob(base64)
  const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0))
  return new TextDecoder('utf-8').decode(bytes)
}

/**
 * Encodes a string to base64 with proper UTF-8 support.
 * Counterpart to decodeBase64Utf8 — btoa() alone mangles multi-byte
 * characters (e.g. é, è, ê), so encode UTF-8 bytes first.
 */
export function encodeBase64Utf8(value: string): string {
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })
  return btoa(binary)
}

/**
 * Reads a File and returns its content as a plain base64 string (no data: prefix).
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const dataUrl = reader.result as string
      resolve(dataUrl.slice(dataUrl.indexOf(',') + 1))
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

/**
 * Sends a command to EfficienceWeb via postMessage
 */
export function sendEfficienceCommand(iframe: HTMLIFrameElement, xmlCommand: string) {
  const base64Request = btoa(xmlCommand)
  iframe.contentWindow?.postMessage(
    JSON.stringify({
      remoteCommand: base64Request,
    }),
    '*'
  )
}
